module.exports = __webpack_public_path__ + "img/ban_3_big.c01cdff9.png";